import { journalBetaApi } from "@/api";
import {
    actionSetChildAttendanceStatus,
    actionSetLessonTypes,
    actionSetStatus
} from "@store/journal.reducer";
import store from '@store/redux.store';

export const checkJournalStore = (forceUpdate = false) => {
    return new Promise((resolve, reject) => {
        if (store.getState().journal.status && !forceUpdate) {
            resolve();
        } else {
            fethStore()
                .then(() => resolve())
                .catch((error) => reject(error));
        }
    })
}

const params = [
    // {
    //     promise: journalBetaApi.getButtonsGradesPopup,
    //     action: actionSetButtonsGradesPopup,
    //     error: 'Типы оценок не загружены!'
    // },
    {
        promise: journalBetaApi.getChildAttendanceStatus,
        action: actionSetChildAttendanceStatus,
        error: 'Статусы посещаемости не загружены!'
    },
    {
        promise: journalBetaApi.getLessonTypes,
        action: actionSetLessonTypes,
        error: 'Типы занятий не загружены!'
    }
];

const fethStore = () => {
    return new Promise((resolve, reject) => {
        store.dispatch(actionSetStatus(1));

        const allPromise = params.map(el => el.promise());

        Promise.all(allPromise)
            .then((res) => {
                let errors = [];

                for (let i = 0; i < params.length; i++) {
                    if (res[i]?.data?.status !== 'success') {
                        errors.push(params[i].error);
                    } else if (!res[i]?.data?.data) {
                        errors.push(params[i].error);
                    } else {
                        store.dispatch(
                            params[i].action(res[i].data.data)
                        );
                    }
                }

                if (errors.length) {
                    store.dispatch(actionSetStatus(0));
                    reject(errors);
                } else {
                    store.dispatch(actionSetStatus(2));
                    resolve();
                }
            })
            .catch((error) => {
                store.dispatch(actionSetStatus(0));
                reject(['Возможно, ошибка сети']);
            })
    });
}
